import { render, staticRenderFns } from "./CallcentreTeam.vue?vue&type=template&id=03e5d847&"
import script from "./CallcentreTeam.vue?vue&type=script&lang=js&"
export * from "./CallcentreTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports